import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import Router from './Router';
import { store } from '../../model/store';
import Locales from '../Locales/Locales';

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Locales>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </Locales>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
